import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import styles from './NotificationPage.module.scss';

export default function NotificationDetailModal({ show, onClose, notification, onConfirm, confirmLabel = 'Confirm' }) {
  if (!notification) return null;

  const createdBy = notification.creator ? `${notification.creator.first_name || ''} ${notification.creator.last_name || ''}`.trim() || notification.creator.email : 'System';

  return (
    <Modal show={show} size="xl" onHide={onClose} centered dialogClassName={styles.detailModalDialog} className="text-black">
      <Modal.Header closeButton>
        <Modal.Title>{notification.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={styles.detailMessage} dangerouslySetInnerHTML={{ __html: notification.message }} />
      </Modal.Body>
      <Modal.Footer>
        <div className={styles.detailMeta}>
          <div><strong>Tag:</strong> {notification.type}</div>
          <div><strong>Sent at:</strong> {notification.created_at ? new Date(notification.created_at).toLocaleTimeString() : '-'}</div>
          <div><strong>Created by:</strong> {createdBy}</div>
        </div>
        {onConfirm ? (
          <div className="ms-3">
            <Button variant="secondary" onClick={onClose} className="me-3">Cancel</Button>
            &nbsp;
            <Button variant="primary" onClick={() => onConfirm(notification)}>{confirmLabel}</Button>
          </div>
        ) : null}
      </Modal.Footer>
    </Modal>
  );
}


